// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"ReportTableV2_buttonsContainer__ZLV91","buttonFont":"ReportTableV2_buttonFont__zWP3U","boldFooterRow":"ReportTableV2_boldFooterRow__W5mqL"};